import React from 'react';

import { ModalForm } from '../../design-system/patterns/modal-form';

/**
 * The in-person safety confirmation.
 *
 * Copy rewritten to drop the em dashes and to lead with the instruction rather
 * than the mechanism. Nothing about the flow changed: Cancel closes, Continue
 * hands on to the payment confirmation.
 *
 * The old markup used `pf-btn-gradient` on the commit, a cyan gradient button.
 * Ink is command; the commit is the library `Button`.
 *
 * `ModalForm` rather than a bare `Modal`, for the reason set out at length in
 * ProceedPaymentModal: below the handoff a confirmation is a bottom sheet, not
 * a centred pointer dialog. This one carries a safety warning about handing
 * over money in person, so it is the last of the three that should be hard to
 * read on the device it is read on.
 */
const InPersonConfirmModal = ({ isOpen, onClose, onContinue }) => (
  <ModalForm
    open={isOpen}
    onClose={onClose}
    title="Confirm in-person purchase"
    onSubmit={() => onContinue && onContinue()}
    submitLabel="Continue"
    cancelLabel="Cancel"
  >
    <p>
      Only continue if the seller is right in front of you with the card in hand and is
      handing it over now.
    </p>
    <p>
      This is an in-person purchase. Payment is released immediately and there is no
      shipping.
    </p>
  </ModalForm>
);

export default InPersonConfirmModal;
